// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OptionItem-module__font-s-10___VlA_S {
  font-size: 10px !important;
}

.OptionItem-module__font-s-12___NIKqb {
  font-size: 12px !important;
}

.OptionItem-module__font-s-13___p0AFy {
  font-size: 13px !important;
}

.OptionItem-module__font-s-14___ibGWZ {
  font-size: 14px !important;
}

.OptionItem-module__font-s-15___fStLp {
  font-size: 15px !important;
}

.OptionItem-module__font-s-16___oR2W5 {
  font-size: 16px !important;
}

.OptionItem-module__font-s-18___QUCV2 {
  font-size: 18px !important;
}

.OptionItem-module__font-s-20___x3IOo {
  font-size: 20px !important;
}

.OptionItem-module__font-s-22___sGyCu {
  font-size: 22px !important;
}

.OptionItem-module__font-s-28___sjsjH {
  font-size: 28px !important;
}

.OptionItem-module__font-w-400___swtcj {
  font-weight: 400 !important;
}

.OptionItem-module__font-w-500___bL__8 {
  font-weight: 500 !important;
}

.OptionItem-module__font-w-600___uhWv3 {
  font-weight: 600 !important;
}

.OptionItem-module__font-w-700___igp4Z {
  font-weight: 700 !important;
}

.OptionItem-module__p-5___aIBOq {
  padding: 5px !important;
}

.OptionItem-module__p-12___g_YGY {
  padding: 12px !important;
}

.OptionItem-module__p-16___BQBPW {
  padding: 16px !important;
}

.OptionItem-module__p-30___uUS_n {
  padding: 30px !important;
}

.OptionItem-module__p-b-0___cSYc4 {
  padding-bottom: 0 !important;
}

.OptionItem-module__p-b-5___QbrM_ {
  padding-bottom: 5px !important;
}

.OptionItem-module__p-b-10___q9hie {
  padding-bottom: 10px !important;
}

.OptionItem-module__p-b-12___TluZy {
  padding-bottom: 12px !important;
}

.OptionItem-module__p-b-16___Hg6Vv {
  padding-bottom: 16px !important;
}

.OptionItem-module__p-b-18___v_45M {
  padding-bottom: 18px !important;
}

.OptionItem-module__p-b-20___sI_jH {
  padding-bottom: 20px !important;
}

.OptionItem-module__p-b-25___GKtxI {
  padding-bottom: 25px !important;
}

.OptionItem-module__p-b-30___pVdAV {
  padding-bottom: 30px !important;
}

.OptionItem-module__p-b-50___eXSqb {
  padding-bottom: 50px !important;
}

.OptionItem-module__p-t-0___opESz {
  padding-top: 0 !important;
}

.OptionItem-module__p-t-12___tG5vM {
  padding-top: 12px !important;
}

.OptionItem-module__p-t-16___gcFVD {
  padding-top: 16px !important;
}

.OptionItem-module__p-t-18___fupji {
  padding-top: 18px !important;
}

.OptionItem-module__p-t-20___aPY8n {
  padding-top: 20px !important;
}

.OptionItem-module__p-t-30___nYayp {
  padding-top: 30px !important;
}

.OptionItem-module__p-t-40___BYF5i {
  padding-top: 40px !important;
}

.OptionItem-module__p-t-50___sa5tg {
  padding-top: 50px !important;
}

.OptionItem-module__p-l-20___PMshP {
  padding-left: 20px !important;
}

.OptionItem-module__p-l-30___Dy7XT {
  padding-left: 30px !important;
}

.OptionItem-module__p-l-40___gcN2C {
  padding-left: 40px !important;
}

.OptionItem-module__p-r-16___omnuj {
  padding-right: 16px !important;
}

.OptionItem-module__p-r-20___upusU {
  padding-right: 20px !important;
}

.OptionItem-module__p-r-30___eA7mq {
  padding-right: 30px !important;
}

.OptionItem-module__p-r-50___ghkj5 {
  padding-right: 50px !important;
}

.OptionItem-module__p-r-60___h09HE {
  padding-right: 60px !important;
}

.OptionItem-module__m-b-1___kXWsk {
  margin-bottom: 1px !important;
}

.OptionItem-module__m-b-2___XxSAO {
  margin-bottom: 2px !important;
}

.OptionItem-module__m-b-6___pKR1a {
  margin-bottom: 6px !important;
}

.OptionItem-module__m-b-8___ONBGj {
  margin-bottom: 8px !important;
}

.OptionItem-module__m-b-10___ttEdq {
  margin-bottom: 10px !important;
}

.OptionItem-module__m-b-14___udBIU {
  margin-bottom: 14px !important;
}

.OptionItem-module__m-b-16___aVaAj {
  margin-bottom: 16px !important;
}

.OptionItem-module__m-b-20___FHGmH {
  margin-bottom: 20px !important;
}

.OptionItem-module__m-b-22___GJezJ {
  margin-bottom: 22px !important;
}

.OptionItem-module__m-b-24___okwuG {
  margin-bottom: 24px !important;
}

.OptionItem-module__m-b-30___LFr_9 {
  margin-bottom: 30px !important;
}

.OptionItem-module__m-b-32___tbaQg {
  margin-bottom: 32px !important;
}

.OptionItem-module__m-b-40___aBMrl {
  margin-bottom: 40px !important;
}

.OptionItem-module__m-t-2___HQkB9 {
  margin-top: 2px !important;
}

.OptionItem-module__m-t-3___PYap6 {
  margin-top: 3px !important;
}

.OptionItem-module__m-t-4___nUl82 {
  margin-top: 4px !important;
}

.OptionItem-module__m-t-5___JkdNV {
  margin-top: 5px !important;
}

.OptionItem-module__m-t-8___RgEIx {
  margin-top: 8px !important;
}

.OptionItem-module__m-t-10___FJAjS {
  margin-top: 10px !important;
}

.OptionItem-module__m-t-15___ODBav {
  margin-top: 15px !important;
}

.OptionItem-module__m-t-16___ZgFva {
  margin-top: 16px !important;
}

.OptionItem-module__m-t-20___tZMR1 {
  margin-top: 20px !important;
}

.OptionItem-module__m-t-22___nxAPC {
  margin-top: 22px !important;
}

.OptionItem-module__m-t-30___fdwnb {
  margin-top: 30px !important;
}

.OptionItem-module__m-t-32___jrXIh {
  margin-top: 32px !important;
}

.OptionItem-module__m-l-auto___oxiG3 {
  margin-left: auto !important;
}

.OptionItem-module__m-l-4___cIdwN {
  margin-left: 4px !important;
}

.OptionItem-module__m-l-5___Ax7Fs {
  margin-left: 5px !important;
}

.OptionItem-module__m-l-6___eolOE {
  margin-left: 6px !important;
}

.OptionItem-module__m-l-8___lUo73 {
  margin-left: 8px !important;
}

.OptionItem-module__m-l-10___vgIdW {
  margin-left: 10px !important;
}

.OptionItem-module__m-l-16___nYBpO {
  margin-left: 16px !important;
}

.OptionItem-module__m-l-20___bTvvB {
  margin-left: 20px !important;
}

.OptionItem-module__m-l-24___NRuLz {
  margin-left: 24px !important;
}

.OptionItem-module__m-l-30____qxFy {
  margin-left: 30px !important;
}

.OptionItem-module__m-l-35___U26_1 {
  margin-left: 35px !important;
}

.OptionItem-module__m-l-40___jiHNd {
  margin-left: 40px !important;
}

.OptionItem-module__m-r-8___aX_sv {
  margin-right: 8px !important;
}

.OptionItem-module__m-r-10____pjo_ {
  margin-right: 10px !important;
}

.OptionItem-module__m-r-16___kvxGP {
  margin-right: 16px !important;
}

.OptionItem-module__m-r-20___jKOnl {
  margin-right: 20px !important;
}

.OptionItem-module__m-r-24___ekfZX {
  margin-right: 24px !important;
}

.OptionItem-module__m-r-30___kEFwT {
  margin-right: 30px !important;
}

.OptionItem-module__m-r-40___TJXXn {
  margin-right: 40px !important;
}

.OptionItem-module__border-r-3___ctMEe {
  border-radius: 3px !important;
}

.OptionItem-module__border-r-4___vWTAh {
  border-radius: 4px !important;
}

.OptionItem-module__border-r-6___SZ5rj {
  border-radius: 6px !important;
}

.OptionItem-module__border-r-10___JeEq_ {
  border-radius: 10px !important;
}

.OptionItem-module__border-r-12___hS6IG {
  border-radius: 12px !important;
}

.OptionItem-module__border-r-16___FQSLF {
  border-radius: 16px !important;
}

.OptionItem-module__border-r-50___rXGLk {
  border-radius: 50% !important;
}

.OptionItem-module__primary-border___zMNKe {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.OptionItem-module__primary-border-b___b9Wd4 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.OptionItem-module__primary-border-t___OdIGQ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.OptionItem-module__primary-border-l___xrlHT {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.OptionItem-module__primary-border-r___u8e0Y {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.OptionItem-module__secondary-border___wbOdR {
  border: 1px solid #637768;
}

.OptionItem-module__secondary-border-b___Vi8Zh {
  border-bottom: 1px solid #637768;
}

.OptionItem-module__secondary-border-t___apI_P {
  border-top: 1px solid #637768;
}

.OptionItem-module__secondary-border-l___nAO0H {
  border-left: 1px solid #637768;
}

.OptionItem-module__secondary-border-r___rRg6p {
  border-right: 1px solid #637768;
}

.OptionItem-module__gap-0___BaNgH {
  gap: 0 !important;
}

.OptionItem-module__gap-2___xqRdF {
  gap: 2px !important;
}

.OptionItem-module__gap-4___z3ni6 {
  gap: 4px !important;
}

.OptionItem-module__gap-5___nS3FG {
  gap: 5px !important;
}

.OptionItem-module__gap-6___n6djW {
  gap: 6px !important;
}

.OptionItem-module__gap-8___Hpay1 {
  gap: 8px !important;
}

.OptionItem-module__gap-10___ORCfs {
  gap: 10px !important;
}

.OptionItem-module__gap-12___g0psA {
  gap: 12px !important;
}

.OptionItem-module__gap-14___ulZFK {
  gap: 14px !important;
}

.OptionItem-module__gap-16___zCikQ {
  gap: 16px !important;
}

.OptionItem-module__gap-18___guOku {
  gap: 18px !important;
}

.OptionItem-module__gap-20___VnTpa {
  gap: 20px !important;
}

.OptionItem-module__gap-24___zrAiy {
  gap: 24px !important;
}

.OptionItem-module__gap-26___XldZ4 {
  gap: 26px !important;
}

.OptionItem-module__gap-30___jz4kV {
  gap: 30px !important;
}

.OptionItem-module__gap-32___ZkOlF {
  gap: 32px !important;
}

.OptionItem-module__gap-40___mAkUx {
  gap: 40px !important;
}

.OptionItem-module__gap-50___quqRa {
  gap: 50px !important;
}

.OptionItem-module__flex-1___jPit8 {
  flex: 1;
}

.OptionItem-module__flex-none___DYTTb {
  flex: none !important;
}

.OptionItem-module__flex-column___iYu_4 {
  display: flex;
  flex-direction: column !important;
}

.OptionItem-module__flex-row___sloUx {
  display: flex;
  flex-direction: row !important;
}

.OptionItem-module__vertically-centered___ZlYyY {
  display: flex;
  align-items: center !important;
}

.OptionItem-module__horizontally-centered___PMLWa {
  display: flex;
  justify-content: center !important;
}

.OptionItem-module__horizontally-end___IFcAC {
  display: flex;
  justify-content: end !important;
}

.OptionItem-module__vertically-start___VPcoT {
  display: flex;
  align-items: start !important;
}

.OptionItem-module__space-between___HoHPp {
  display: flex;
  justify-content: space-between !important;
}

.OptionItem-module__flex-wrap___KxW8W {
  flex-wrap: wrap !important;
}

.OptionItem-module__height-100___wRKDC {
  height: 100%;
}

.OptionItem-module__width-50___VxxkT {
  width: 50% !important;
}

.OptionItem-module__width-100___I8dKD {
  width: 100%;
}

.OptionItem-module__cursor-pointer___Q_77h {
  cursor: pointer;
}

.OptionItem-module__cursor-not-allowed___l05jP {
  cursor: not-allowed !important;
}

.OptionItem-module__absolute-centered___ZeBtb {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.OptionItem-module__absolute___vkbuW {
  position: absolute;
}

.OptionItem-module__relative___vdMlJ {
  position: relative;
}

.OptionItem-module__fixed___Ilwm6 {
  position: fixed;
}

.OptionItem-module__visible___Tj2kg {
  opacity: 1;
}

.OptionItem-module__invisible___xa4mg {
  opacity: 0;
}

.OptionItem-module__col-90___uXQHI {
  width: 90% !important;
}

.OptionItem-module__col-auto___m4I79 {
  width: auto !important;
}

.OptionItem-module__medical-tabs___pTeRy {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.OptionItem-module__medical-table-new___ahD3C {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.OptionItem-module__medical-table-new___ahD3C:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.OptionItem-module__medical-table-new___ahD3C::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.OptionItem-module__medical-table-new___ahD3C::-webkit-scrollbar-track {
  display: none;
}
.OptionItem-module__medical-table-new___ahD3C.OptionItem-module__no-pagination___nu3jO {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.OptionItem-module__medical-table-new___ahD3C.OptionItem-module__no-pagination___nu3jO:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.OptionItem-module__medical-table-new___ahD3C.OptionItem-module__no-pagination___nu3jO::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.OptionItem-module__medical-table-new___ahD3C.OptionItem-module__no-pagination___nu3jO::-webkit-scrollbar-track {
  display: none;
}

.OptionItem-module__medical-table-empty___g2I_G {
  padding: 14px 40px !important;
}

.OptionItem-module__icon-btn___oaF57 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.OptionItem-module__search-icon___R7xdl {
  width: 24px;
  height: 24px;
  align-self: center;
}

.OptionItem-module__disable-select___Qmp_8 {
  user-select: none;
}

.OptionItem-module__break-word___GA6hX {
  word-break: break-word;
}

.OptionItem-module__popup-clear-btn___ttCgD {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.OptionItem-module__scroll-m-b-20___Ahv8E {
  scroll-margin-bottom: 20px;
}

.OptionItem-module__option___RtqZ6 {
  padding: 12px 14px;
  color: #375844;
}
.OptionItem-module__option___RtqZ6:hover {
  background-color: #f1f3e7;
}
.OptionItem-module__option___RtqZ6 .OptionItem-module__icon___EuT0c {
  width: 13px;
  height: 13px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/PatientDetailsNavigation/items/OptionItem/OptionItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,cAAA;AA8pBF;AA5pBE;EACE,yBAAA;AA8pBJ;AA3pBE;EACE,WAAA;EACA,YAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.option {\n  padding: 12px 14px;\n  color: get-color(greenNew, dark);\n\n  &:hover {\n    background-color: get-color(greenNew, lighter);\n  }\n\n  .icon {\n    width: 13px;\n    height: 13px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `OptionItem-module__font-s-10___VlA_S`,
	"fontS12": `OptionItem-module__font-s-12___NIKqb`,
	"fontS13": `OptionItem-module__font-s-13___p0AFy`,
	"fontS14": `OptionItem-module__font-s-14___ibGWZ`,
	"fontS15": `OptionItem-module__font-s-15___fStLp`,
	"fontS16": `OptionItem-module__font-s-16___oR2W5`,
	"fontS18": `OptionItem-module__font-s-18___QUCV2`,
	"fontS20": `OptionItem-module__font-s-20___x3IOo`,
	"fontS22": `OptionItem-module__font-s-22___sGyCu`,
	"fontS28": `OptionItem-module__font-s-28___sjsjH`,
	"fontW400": `OptionItem-module__font-w-400___swtcj`,
	"fontW500": `OptionItem-module__font-w-500___bL__8`,
	"fontW600": `OptionItem-module__font-w-600___uhWv3`,
	"fontW700": `OptionItem-module__font-w-700___igp4Z`,
	"p5": `OptionItem-module__p-5___aIBOq`,
	"p12": `OptionItem-module__p-12___g_YGY`,
	"p16": `OptionItem-module__p-16___BQBPW`,
	"p30": `OptionItem-module__p-30___uUS_n`,
	"pB0": `OptionItem-module__p-b-0___cSYc4`,
	"pB5": `OptionItem-module__p-b-5___QbrM_`,
	"pB10": `OptionItem-module__p-b-10___q9hie`,
	"pB12": `OptionItem-module__p-b-12___TluZy`,
	"pB16": `OptionItem-module__p-b-16___Hg6Vv`,
	"pB18": `OptionItem-module__p-b-18___v_45M`,
	"pB20": `OptionItem-module__p-b-20___sI_jH`,
	"pB25": `OptionItem-module__p-b-25___GKtxI`,
	"pB30": `OptionItem-module__p-b-30___pVdAV`,
	"pB50": `OptionItem-module__p-b-50___eXSqb`,
	"pT0": `OptionItem-module__p-t-0___opESz`,
	"pT12": `OptionItem-module__p-t-12___tG5vM`,
	"pT16": `OptionItem-module__p-t-16___gcFVD`,
	"pT18": `OptionItem-module__p-t-18___fupji`,
	"pT20": `OptionItem-module__p-t-20___aPY8n`,
	"pT30": `OptionItem-module__p-t-30___nYayp`,
	"pT40": `OptionItem-module__p-t-40___BYF5i`,
	"pT50": `OptionItem-module__p-t-50___sa5tg`,
	"pL20": `OptionItem-module__p-l-20___PMshP`,
	"pL30": `OptionItem-module__p-l-30___Dy7XT`,
	"pL40": `OptionItem-module__p-l-40___gcN2C`,
	"pR16": `OptionItem-module__p-r-16___omnuj`,
	"pR20": `OptionItem-module__p-r-20___upusU`,
	"pR30": `OptionItem-module__p-r-30___eA7mq`,
	"pR50": `OptionItem-module__p-r-50___ghkj5`,
	"pR60": `OptionItem-module__p-r-60___h09HE`,
	"mB1": `OptionItem-module__m-b-1___kXWsk`,
	"mB2": `OptionItem-module__m-b-2___XxSAO`,
	"mB6": `OptionItem-module__m-b-6___pKR1a`,
	"mB8": `OptionItem-module__m-b-8___ONBGj`,
	"mB10": `OptionItem-module__m-b-10___ttEdq`,
	"mB14": `OptionItem-module__m-b-14___udBIU`,
	"mB16": `OptionItem-module__m-b-16___aVaAj`,
	"mB20": `OptionItem-module__m-b-20___FHGmH`,
	"mB22": `OptionItem-module__m-b-22___GJezJ`,
	"mB24": `OptionItem-module__m-b-24___okwuG`,
	"mB30": `OptionItem-module__m-b-30___LFr_9`,
	"mB32": `OptionItem-module__m-b-32___tbaQg`,
	"mB40": `OptionItem-module__m-b-40___aBMrl`,
	"mT2": `OptionItem-module__m-t-2___HQkB9`,
	"mT3": `OptionItem-module__m-t-3___PYap6`,
	"mT4": `OptionItem-module__m-t-4___nUl82`,
	"mT5": `OptionItem-module__m-t-5___JkdNV`,
	"mT8": `OptionItem-module__m-t-8___RgEIx`,
	"mT10": `OptionItem-module__m-t-10___FJAjS`,
	"mT15": `OptionItem-module__m-t-15___ODBav`,
	"mT16": `OptionItem-module__m-t-16___ZgFva`,
	"mT20": `OptionItem-module__m-t-20___tZMR1`,
	"mT22": `OptionItem-module__m-t-22___nxAPC`,
	"mT30": `OptionItem-module__m-t-30___fdwnb`,
	"mT32": `OptionItem-module__m-t-32___jrXIh`,
	"mLAuto": `OptionItem-module__m-l-auto___oxiG3`,
	"mL4": `OptionItem-module__m-l-4___cIdwN`,
	"mL5": `OptionItem-module__m-l-5___Ax7Fs`,
	"mL6": `OptionItem-module__m-l-6___eolOE`,
	"mL8": `OptionItem-module__m-l-8___lUo73`,
	"mL10": `OptionItem-module__m-l-10___vgIdW`,
	"mL16": `OptionItem-module__m-l-16___nYBpO`,
	"mL20": `OptionItem-module__m-l-20___bTvvB`,
	"mL24": `OptionItem-module__m-l-24___NRuLz`,
	"mL30": `OptionItem-module__m-l-30____qxFy`,
	"mL35": `OptionItem-module__m-l-35___U26_1`,
	"mL40": `OptionItem-module__m-l-40___jiHNd`,
	"mR8": `OptionItem-module__m-r-8___aX_sv`,
	"mR10": `OptionItem-module__m-r-10____pjo_`,
	"mR16": `OptionItem-module__m-r-16___kvxGP`,
	"mR20": `OptionItem-module__m-r-20___jKOnl`,
	"mR24": `OptionItem-module__m-r-24___ekfZX`,
	"mR30": `OptionItem-module__m-r-30___kEFwT`,
	"mR40": `OptionItem-module__m-r-40___TJXXn`,
	"borderR3": `OptionItem-module__border-r-3___ctMEe`,
	"borderR4": `OptionItem-module__border-r-4___vWTAh`,
	"borderR6": `OptionItem-module__border-r-6___SZ5rj`,
	"borderR10": `OptionItem-module__border-r-10___JeEq_`,
	"borderR12": `OptionItem-module__border-r-12___hS6IG`,
	"borderR16": `OptionItem-module__border-r-16___FQSLF`,
	"borderR50": `OptionItem-module__border-r-50___rXGLk`,
	"primaryBorder": `OptionItem-module__primary-border___zMNKe`,
	"primaryBorderB": `OptionItem-module__primary-border-b___b9Wd4`,
	"primaryBorderT": `OptionItem-module__primary-border-t___OdIGQ`,
	"primaryBorderL": `OptionItem-module__primary-border-l___xrlHT`,
	"primaryBorderR": `OptionItem-module__primary-border-r___u8e0Y`,
	"secondaryBorder": `OptionItem-module__secondary-border___wbOdR`,
	"secondaryBorderB": `OptionItem-module__secondary-border-b___Vi8Zh`,
	"secondaryBorderT": `OptionItem-module__secondary-border-t___apI_P`,
	"secondaryBorderL": `OptionItem-module__secondary-border-l___nAO0H`,
	"secondaryBorderR": `OptionItem-module__secondary-border-r___rRg6p`,
	"gap0": `OptionItem-module__gap-0___BaNgH`,
	"gap2": `OptionItem-module__gap-2___xqRdF`,
	"gap4": `OptionItem-module__gap-4___z3ni6`,
	"gap5": `OptionItem-module__gap-5___nS3FG`,
	"gap6": `OptionItem-module__gap-6___n6djW`,
	"gap8": `OptionItem-module__gap-8___Hpay1`,
	"gap10": `OptionItem-module__gap-10___ORCfs`,
	"gap12": `OptionItem-module__gap-12___g0psA`,
	"gap14": `OptionItem-module__gap-14___ulZFK`,
	"gap16": `OptionItem-module__gap-16___zCikQ`,
	"gap18": `OptionItem-module__gap-18___guOku`,
	"gap20": `OptionItem-module__gap-20___VnTpa`,
	"gap24": `OptionItem-module__gap-24___zrAiy`,
	"gap26": `OptionItem-module__gap-26___XldZ4`,
	"gap30": `OptionItem-module__gap-30___jz4kV`,
	"gap32": `OptionItem-module__gap-32___ZkOlF`,
	"gap40": `OptionItem-module__gap-40___mAkUx`,
	"gap50": `OptionItem-module__gap-50___quqRa`,
	"flex1": `OptionItem-module__flex-1___jPit8`,
	"flexNone": `OptionItem-module__flex-none___DYTTb`,
	"flexColumn": `OptionItem-module__flex-column___iYu_4`,
	"flexRow": `OptionItem-module__flex-row___sloUx`,
	"verticallyCentered": `OptionItem-module__vertically-centered___ZlYyY`,
	"horizontallyCentered": `OptionItem-module__horizontally-centered___PMLWa`,
	"horizontallyEnd": `OptionItem-module__horizontally-end___IFcAC`,
	"verticallyStart": `OptionItem-module__vertically-start___VPcoT`,
	"spaceBetween": `OptionItem-module__space-between___HoHPp`,
	"flexWrap": `OptionItem-module__flex-wrap___KxW8W`,
	"height100": `OptionItem-module__height-100___wRKDC`,
	"width50": `OptionItem-module__width-50___VxxkT`,
	"width100": `OptionItem-module__width-100___I8dKD`,
	"cursorPointer": `OptionItem-module__cursor-pointer___Q_77h`,
	"cursorNotAllowed": `OptionItem-module__cursor-not-allowed___l05jP`,
	"absoluteCentered": `OptionItem-module__absolute-centered___ZeBtb`,
	"absolute": `OptionItem-module__absolute___vkbuW`,
	"relative": `OptionItem-module__relative___vdMlJ`,
	"fixed": `OptionItem-module__fixed___Ilwm6`,
	"visible": `OptionItem-module__visible___Tj2kg`,
	"invisible": `OptionItem-module__invisible___xa4mg`,
	"col90": `OptionItem-module__col-90___uXQHI`,
	"colAuto": `OptionItem-module__col-auto___m4I79`,
	"medicalTabs": `OptionItem-module__medical-tabs___pTeRy`,
	"medicalTableNew": `OptionItem-module__medical-table-new___ahD3C`,
	"noPagination": `OptionItem-module__no-pagination___nu3jO`,
	"medicalTableEmpty": `OptionItem-module__medical-table-empty___g2I_G`,
	"iconBtn": `OptionItem-module__icon-btn___oaF57`,
	"searchIcon": `OptionItem-module__search-icon___R7xdl`,
	"disableSelect": `OptionItem-module__disable-select___Qmp_8`,
	"breakWord": `OptionItem-module__break-word___GA6hX`,
	"popupClearBtn": `OptionItem-module__popup-clear-btn___ttCgD`,
	"scrollMB20": `OptionItem-module__scroll-m-b-20___Ahv8E`,
	"option": `OptionItem-module__option___RtqZ6`,
	"icon": `OptionItem-module__icon___EuT0c`
};
module.exports = ___CSS_LOADER_EXPORT___;
